<template>
  <section class="twenty-section">
    <div class="container">
      <p class="textTwenty1">
        2020 год был, мягко говоря, непростым. Мир сильно изменился и мы с вами тоже
      </p>
      <p class="textTwenty2">
        МТС представляет ТОП-10 событий уходящего года, которые дают надежду,
        что 2021 обязательно будет хорошим годом
      </p>
      <div class="twenty-image">
        <svg class="back-twenty" viewBox="0 0 264 128" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="glass-twenty" fill-rule="evenodd" clip-rule="evenodd"
                d="M47.5 37.1115L39.5 17.0303L16 12.3447C6.61411 18.7501
                1.1262 28.8008 0.169666 43.9278H42.247C43.2083 40.6299
                44.7748 38.4714 47.5 37.1115Z" fill="url(#paint0_linear)"/>
          <path class="glass-twenty__1"
                d="M61.7587 2.53027C42.1484 2.53027 26.5921 5.11623 16
                12.3447L39.5 17.0303L50.6293 9.78027L61.7587 2.53027Z"
                fill="url(#paint1_linear)"/>
          <path class="glass-twenty__2"
                d="M47.5 37.1115C50.5467 35.5912 55.0418 35.069 61.7587
                35.069L50.6293 9.78027L39.5 17.0303L47.5 37.1115Z"
                fill="url(#paint2_linear)"/>
          <path class="glass-twenty__3"
                d="M61.7587 2.53027L50.6293 9.78027L61.7587 35.069C65.4517
                35.069 68.7522 35.1085 71.5 35.4352L75.5 17.0303C73.1667
                13.1969 67.1517 4.93027 61.7587 2.53027Z" fill="url(#paint3_linear)"/>
          <path class="glass-twenty__4"
                d="M61.7587 2.53027C67.1517 4.93027 73.1667 13.1969 75.5
                17.0303L97.5 7.25402C87.918 3.91997 75.8072 2.53027
                61.7587 2.53027Z" fill="url(#paint4_linear)"/>
          <path class="glass-twenty__5"
                d="M80.0827 42.3945V43.5871L121.651 40.3502C121.651
                22.8568 112.799 12.5772 97.5 7.25402L75.5 17.0303L71.5
                35.4352C76.8317 36.0693 80.0827 37.7853 80.0827 42.3945Z"
                fill="url(#paint5_linear)"/>
          <path class="glass-twenty__6"
                d="M121.651 40.3502L80.0827 43.5871L89.1258 54.7048L103
                71.7619C113.739 65.5251 121.651 55.9306 121.651 40.3502Z"
                fill="url(#paint6_linear)"/>
          <path class="glass-twenty__7"
                d="M89.1258 54.7048L80.0827 43.5871C80.0827 49.1597
                70.385 51.3077 57.7391 54.1089C54.4831 54.8301 51.0317
                55.5946 47.5 56.472L89.1258 54.7048Z" fill="url(#paint7_linear)"/>
          <path class="glass-twenty__8"
                d="M89.1258 54.7048L47.5 56.472L55 65.5303L69
                82.7191C74.8333 73.4181 87.0252 54.794 89.1258
                54.7048Z" fill="url(#paint8_linear)"/>
          <path class="glass-twenty__9"
                d="M103 71.7619L89.1258 54.7048C87.0252 54.794 74.8333
                73.4181 69 82.7191C79.9662 80.5995 92.7665 77.7053 103
                71.7619Z" fill="url(#paint9_linear)"/>
          <path class="glass-twenty__10"
                d="M55 65.5303L47.5 56.472C36.6428 59.1694 25.0271
                62.9336 16 69.787L55 65.5303Z" fill="url(#paint10_linear)"/>
          <path class="glass-twenty__11"
                d="M55 65.5303L16 69.787L20.5 90.4361L37 78.0303L55
                65.5303Z" fill="url(#paint11_linear)"/>
          <path class="glass-twenty__12"
                d="M69 82.7191L55 65.5303L37 78.0303L45.1313
                90.4361C46.0442 87.0393 54.044 85.5366 64.5534
                83.5626L64.5557 83.5622C65.994 83.292 67.4794
                83.013 69 82.7191Z" fill="url(#paint12_linear)"/>
          <path class="glass-twenty__13"
                d="M45.1313 90.4361L37 78.0303L20.5 90.4361L0
                103.554L29.4586 94.9915L45.1313 90.4361Z" fill="url(#paint13_linear)"/>
          <path class="glass-twenty__14"
                d="M16 69.787C6.59507 76.9272 0 87.4206 0 103.554L20.5
                90.4361L16 69.787Z" fill="url(#paint14_linear)"/>
          <path class="glass-twenty__15"
                d="M0 103.554V122.805L14.7293 108.898L29.4586
                94.9915L0 103.554Z" fill="url(#paint15_linear)"/>
          <path class="glass-twenty__16"
                d="M45.1313 90.4361L29.4586 94.9915L14.7293 108.898L47.406
                106.226L80.0827 103.554L94.5 90.4361H45.1313Z" fill="url(#paint16_linear)"/>
          <path class="glass-twenty__17"
                d="M14.7293 108.898L0 122.805H61.7587L47.406
                106.226L14.7293 108.898Z" fill="url(#paint17_linear)"/>
          <path class="glass-twenty__18"
                d="M87.2913 113.179L80.0827 103.554L47.406 106.226L61.7587
                122.805H94.5L87.2913 113.179Z" fill="url(#paint18_linear)"/>
          <path class="glass-twenty__19"
                d="M120.294 90.4361H94.5L80.0827 103.554L87.2913
                113.179L120.294 99.5303V90.4361Z" fill="url(#paint19_linear)"/>
          <path class="glass-twenty__20"
                d="M94.5 122.805H120.294V99.5303L87.2913
                113.179L94.5 122.805Z" fill="url(#paint20_linear)"/>
          <path class="glass-twenty__21"
                d="M182.5 1.47355C161.172 4.21284 145.21 13.2635
                137.728 33.069L151.715 30.6844L165.702 28.2997L193.676
                23.5303L182.5 1.47355Z" fill="url(#paint21_linear)"/>
          <path class="glass-twenty__22"
                d="M137.728 33.069C134.659 41.1935 133.017 51.1277
                133.017 63.1785L151.715 30.6844L137.728 33.069Z"
                fill="url(#paint22_linear)"/>
          <path class="glass-twenty__23"
                d="M175.773 54.7048L165.702 28.2997L151.715
                30.6844L133.017 63.1785L175.773 54.7048Z"
                fill="url(#paint23_linear)"/>
          <path class="glass-twenty__24"
                d="M175.773 54.7048C175.773 36.1355 185.784 33.069
                198.509 33.069L193.676 23.5303L165.702 28.2997L175.773
                54.7048Z" fill="url(#paint24_linear)"/>
          <path class="glass-twenty__25"
                d="M133.017 63.1785C133.017 70.4231 133.564 76.9143
                134.615 82.7191L155.194 68.7119L175.773
                54.7048L133.017 63.1785Z" fill="url(#paint25_linear)"/>
          <path class="glass-twenty__26"
                d="M198.509 94.9915C185.784 94.8211 175.773 93.6286
                175.773 73.015V54.7048L155.194 68.7119L162.5
                94.9915H198.509Z" fill="url(#paint26_linear)"/>
          <path class="glass-twenty__27"
                d="M155.194 68.7119L134.615 82.7191C137.991 101.359
                146.575 112.921 159 119.621L162.5 94.9915L155.194
                68.7119Z" fill="url(#paint27_linear)"/>
          <path class="glass-twenty__28"
                d="M198.509 94.9915H162.5L159 119.621C163.999 122.316
                169.62 124.225 175.773 125.491L182.5 108.898L198.509
                94.9915Z" fill="url(#paint28_linear)"/>
          <path class="glass-twenty__29"
                d="M198.509 127.53L182.5 108.898L175.773 125.491C182.716
                126.92 190.337 127.53 198.509 127.53Z"
                fill="url(#paint29_linear)"/>
          <path class="glass-twenty__30"
                d="M182.5 108.898L198.509 127.53C203.559 127.53
                208.4 127.297 213 126.781L214.593 108.609L216.186
                90.4361C212.046 94.5547 205.712 94.9915 198.509
                94.9915L182.5 108.898Z" fill="url(#paint30_linear)"/>
          <path class="glass-twenty__31"
                d="M214.593 108.609L213 126.781C233.094 124.53
                248.599 116.892 257 99.7894L214.593 108.609Z"
                fill="url(#paint31_linear)"/>
          <path class="glass-twenty__32"
                d="M221.244 73.015C221.244 81.9593 219.359 87.2792
                216.186 90.4361L214.593 108.609L257 99.7894C259.112
                95.4896 260.775 90.5915 261.95 85.0303L221.244
                73.015Z" fill="url(#paint32_linear)"/>
          <path class="glass-twenty__33"
                d="M221.244 54.7048V73.015L261.95 85.0303C263.296
                78.6514 264 71.4001 264 63.1785L249.5 65.5303L239.5
                43.5871L221.244 54.7048Z" fill="url(#paint33_linear)"/>
          <path class="glass-twenty__34"
                d="M239.5 43.5871L249.5 65.5303L264 63.1785C264 37.8053
                256.721 21.8151 244.168 12.3447L238 21.5303L239.5
                43.5871Z" fill="url(#paint34_linear)"/>
          <path class="glass-twenty__35"
                d="M221.244 54.7048L239.5 43.5871L238 21.5303L244.168
                12.3447C238.281 7.90316 231.235 4.89569 223.235
                3.02696L211.202 35.069C217.294 37.652 221.244 43.2542
                221.244 54.7048Z" fill="url(#paint35_linear)"/>
          <path class="glass-twenty__36"
                d="M198.509 0.530273C192.899 0.530273 187.549 0.825046
                    182.5 1.47355L193.676 23.5303L198.509
                    33.069C203.24 33.069 207.596 33.5401 211.202
                    35.069L223.235 3.02696C215.767 1.2824 207.469
                    0.530273 198.509 0.530273Z" fill="url(#paint36_linear)"/>
          <defs>
            <linearGradient id="paint0_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint1_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint2_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint3_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint4_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint5_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint6_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint7_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint8_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint9_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint10_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint11_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint12_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint13_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint14_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint15_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint16_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint17_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint18_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint19_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint20_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint21_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint22_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint23_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint24_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint25_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint26_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint27_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint28_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint29_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint30_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint31_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint32_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint33_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint34_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint35_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint36_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
          </defs>
        </svg>
        <svg class="front-twenty" viewBox="0 0 264 128" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="glass-twenty" fill-rule="evenodd" clip-rule="evenodd"
                d="M47.5 37.1115L39.5 17.0303L16 12.3447C6.61411 18.7501
                1.1262 28.8008 0.169666 43.9278H42.247C43.2083 40.6299
                44.7748 38.4714 47.5 37.1115Z" fill="url(#paint0_linear)"/>
          <path class="glass-twenty__1"
                d="M61.7587 2.53027C42.1484 2.53027 26.5921 5.11623 16
                12.3447L39.5 17.0303L50.6293 9.78027L61.7587 2.53027Z"
                fill="url(#paint1_linear)"/>
          <path class="glass-twenty__2"
                d="M47.5 37.1115C50.5467 35.5912 55.0418 35.069 61.7587
                35.069L50.6293 9.78027L39.5 17.0303L47.5 37.1115Z"
                fill="url(#paint2_linear)"/>
          <path class="glass-twenty__3"
                d="M61.7587 2.53027L50.6293 9.78027L61.7587 35.069C65.4517
                35.069 68.7522 35.1085 71.5 35.4352L75.5 17.0303C73.1667
                13.1969 67.1517 4.93027 61.7587 2.53027Z" fill="url(#paint3_linear)"/>
          <path class="glass-twenty__4"
                d="M61.7587 2.53027C67.1517 4.93027 73.1667 13.1969 75.5
                17.0303L97.5 7.25402C87.918 3.91997 75.8072 2.53027
                61.7587 2.53027Z" fill="url(#paint4_linear)"/>
          <path class="glass-twenty__5"
                d="M80.0827 42.3945V43.5871L121.651 40.3502C121.651
                22.8568 112.799 12.5772 97.5 7.25402L75.5 17.0303L71.5
                35.4352C76.8317 36.0693 80.0827 37.7853 80.0827 42.3945Z"
                fill="url(#paint5_linear)"/>
          <path class="glass-twenty__6"
                d="M121.651 40.3502L80.0827 43.5871L89.1258 54.7048L103
                71.7619C113.739 65.5251 121.651 55.9306 121.651 40.3502Z"
                fill="url(#paint6_linear)"/>
          <path class="glass-twenty__7"
                d="M89.1258 54.7048L80.0827 43.5871C80.0827 49.1597
                70.385 51.3077 57.7391 54.1089C54.4831 54.8301 51.0317
                55.5946 47.5 56.472L89.1258 54.7048Z" fill="url(#paint7_linear)"/>
          <path class="glass-twenty__8"
                d="M89.1258 54.7048L47.5 56.472L55 65.5303L69
                82.7191C74.8333 73.4181 87.0252 54.794 89.1258
                54.7048Z" fill="url(#paint8_linear)"/>
          <path class="glass-twenty__9"
                d="M103 71.7619L89.1258 54.7048C87.0252 54.794 74.8333
                73.4181 69 82.7191C79.9662 80.5995 92.7665 77.7053 103
                71.7619Z" fill="url(#paint9_linear)"/>
          <path class="glass-twenty__10"
                d="M55 65.5303L47.5 56.472C36.6428 59.1694 25.0271
                62.9336 16 69.787L55 65.5303Z" fill="url(#paint10_linear)"/>
          <path class="glass-twenty__11"
                d="M55 65.5303L16 69.787L20.5 90.4361L37 78.0303L55
                65.5303Z" fill="url(#paint11_linear)"/>
          <path class="glass-twenty__12"
                d="M69 82.7191L55 65.5303L37 78.0303L45.1313
                90.4361C46.0442 87.0393 54.044 85.5366 64.5534
                83.5626L64.5557 83.5622C65.994 83.292 67.4794
                83.013 69 82.7191Z" fill="url(#paint12_linear)"/>
          <path class="glass-twenty__13"
                d="M45.1313 90.4361L37 78.0303L20.5 90.4361L0
                103.554L29.4586 94.9915L45.1313 90.4361Z" fill="url(#paint13_linear)"/>
          <path class="glass-twenty__14"
                d="M16 69.787C6.59507 76.9272 0 87.4206 0 103.554L20.5
                90.4361L16 69.787Z" fill="url(#paint14_linear)"/>
          <path class="glass-twenty__15"
                d="M0 103.554V122.805L14.7293 108.898L29.4586
                94.9915L0 103.554Z" fill="url(#paint15_linear)"/>
          <path class="glass-twenty__16"
                d="M45.1313 90.4361L29.4586 94.9915L14.7293 108.898L47.406
                106.226L80.0827 103.554L94.5 90.4361H45.1313Z" fill="url(#paint16_linear)"/>
          <path class="glass-twenty__17"
                d="M14.7293 108.898L0 122.805H61.7587L47.406
                106.226L14.7293 108.898Z" fill="url(#paint17_linear)"/>
          <path class="glass-twenty__18"
                d="M87.2913 113.179L80.0827 103.554L47.406 106.226L61.7587
                122.805H94.5L87.2913 113.179Z" fill="url(#paint18_linear)"/>
          <path class="glass-twenty__19"
                d="M120.294 90.4361H94.5L80.0827 103.554L87.2913
                113.179L120.294 99.5303V90.4361Z" fill="url(#paint19_linear)"/>
          <path class="glass-twenty__20"
                d="M94.5 122.805H120.294V99.5303L87.2913
                113.179L94.5 122.805Z" fill="url(#paint20_linear)"/>
          <path class="glass-twenty__21"
                d="M182.5 1.47355C161.172 4.21284 145.21 13.2635
                137.728 33.069L151.715 30.6844L165.702 28.2997L193.676
                23.5303L182.5 1.47355Z" fill="url(#paint21_linear)"/>
          <path class="glass-twenty__22"
                d="M137.728 33.069C134.659 41.1935 133.017 51.1277
                133.017 63.1785L151.715 30.6844L137.728 33.069Z"
                fill="url(#paint22_linear)"/>
          <path class="glass-twenty__23"
                d="M175.773 54.7048L165.702 28.2997L151.715
                30.6844L133.017 63.1785L175.773 54.7048Z"
                fill="url(#paint23_linear)"/>
          <path class="glass-twenty__24"
                d="M175.773 54.7048C175.773 36.1355 185.784 33.069
                198.509 33.069L193.676 23.5303L165.702 28.2997L175.773
                54.7048Z" fill="url(#paint24_linear)"/>
          <path class="glass-twenty__25"
                d="M133.017 63.1785C133.017 70.4231 133.564 76.9143
                134.615 82.7191L155.194 68.7119L175.773
                54.7048L133.017 63.1785Z" fill="url(#paint25_linear)"/>
          <path class="glass-twenty__26"
                d="M198.509 94.9915C185.784 94.8211 175.773 93.6286
                175.773 73.015V54.7048L155.194 68.7119L162.5
                94.9915H198.509Z" fill="url(#paint26_linear)"/>
          <path class="glass-twenty__27"
                d="M155.194 68.7119L134.615 82.7191C137.991 101.359
                146.575 112.921 159 119.621L162.5 94.9915L155.194
                68.7119Z" fill="url(#paint27_linear)"/>
          <path class="glass-twenty__28"
                d="M198.509 94.9915H162.5L159 119.621C163.999 122.316
                169.62 124.225 175.773 125.491L182.5 108.898L198.509
                94.9915Z" fill="url(#paint28_linear)"/>
          <path class="glass-twenty__29"
                d="M198.509 127.53L182.5 108.898L175.773 125.491C182.716
                126.92 190.337 127.53 198.509 127.53Z"
                fill="url(#paint29_linear)"/>
          <path class="glass-twenty__30"
                d="M182.5 108.898L198.509 127.53C203.559 127.53
                208.4 127.297 213 126.781L214.593 108.609L216.186
                90.4361C212.046 94.5547 205.712 94.9915 198.509
                94.9915L182.5 108.898Z" fill="url(#paint30_linear)"/>
          <path class="glass-twenty__31"
                d="M214.593 108.609L213 126.781C233.094 124.53
                248.599 116.892 257 99.7894L214.593 108.609Z"
                fill="url(#paint31_linear)"/>
          <path class="glass-twenty__32"
                d="M221.244 73.015C221.244 81.9593 219.359 87.2792
                216.186 90.4361L214.593 108.609L257 99.7894C259.112
                95.4896 260.775 90.5915 261.95 85.0303L221.244
                73.015Z" fill="url(#paint32_linear)"/>
          <path class="glass-twenty__33"
                d="M221.244 54.7048V73.015L261.95 85.0303C263.296
                78.6514 264 71.4001 264 63.1785L249.5 65.5303L239.5
                43.5871L221.244 54.7048Z" fill="url(#paint33_linear)"/>
          <path class="glass-twenty__34"
                d="M239.5 43.5871L249.5 65.5303L264 63.1785C264 37.8053
                256.721 21.8151 244.168 12.3447L238 21.5303L239.5
                43.5871Z" fill="url(#paint34_linear)"/>
          <path class="glass-twenty__35"
                d="M221.244 54.7048L239.5 43.5871L238 21.5303L244.168
                12.3447C238.281 7.90316 231.235 4.89569 223.235
                3.02696L211.202 35.069C217.294 37.652 221.244 43.2542
                221.244 54.7048Z" fill="url(#paint35_linear)"/>
          <path class="glass-twenty__36"
                d="M198.509 0.530273C192.899 0.530273 187.549 0.825046
                    182.5 1.47355L193.676 23.5303L198.509
                    33.069C203.24 33.069 207.596 33.5401 211.202
                    35.069L223.235 3.02696C215.767 1.2824 207.469
                    0.530273 198.509 0.530273Z" fill="url(#paint36_linear)"/>
          <defs>
            <linearGradient id="paint0_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint1_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint2_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint3_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint4_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint5_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint6_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint7_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint8_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint9_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint10_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint11_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint12_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint13_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint14_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint15_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint16_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint17_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint18_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint19_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint20_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint21_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint22_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint23_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint24_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint25_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint26_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint27_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint28_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint29_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint30_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint31_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint32_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint33_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint34_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint35_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
            <linearGradient id="paint36_linear" x1="132" y1="2.53027"
                            x2="132" y2="125.53" gradientUnits="userSpaceOnUse">
              <stop stop-color="#DBDBDB"/>
              <stop offset="1" stop-color="#8D8D8D"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap, TweenMax } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'v-twenty-section',
  mounted() {
    const timelineShutter = gsap.timeline({
      scrollTrigger: {
        trigger: '.twenty-section',
        start: '0%',
        end: 'bottom',
        scrub: 1,
      },
    });
    timelineShutter.addLabel('start')
      .to('.front-twenty .glass-twenty__1', {
        duration: 1,
        x: -50,
        y: -50,
        rotate: -70,
      })
      .to('.front-twenty .glass-twenty__2', {
        duration: 1,
        x: -23,
        y: -80,
        rotate: 20,
        scale: 1.1,
      }, '-=1')
      .to('.textTwenty1', {
        duration: 1,
        y: -40,
      }, '-=1')
      .to('.textTwenty2', {
        duration: 1,
        y: -40,
      }, '-=1')
      .to('.front-twenty .glass-twenty', {
        duration: 1,
        x: -23,
        y: -35,
        rotate: 20,
        scale: 1.1,
      }, '-=1')
      .to('.front-twenty .glass-twenty__3', {
        duration: 1,
        x: -43,
        y: -10,
        rotate: -90,
      }, '-=1')
      .to('.front-twenty .glass-twenty__4', {
        duration: 1,
        x: -3,
        y: -50,
        rotate: -10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__5', {
        duration: 1,
        x: 3,
        y: -30,
        rotate: 10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__6', {
        duration: 1,
        x: -3,
        y: -20,
        rotate: 20,
      }, '-=1')
      .to('.front-twenty .glass-twenty__7', {
        duration: 1,
        x: -3,
        y: -20,
        rotate: 20,
      }, '-=1')
      .to('.front-twenty .glass-twenty__8', {
        duration: 1,
        x: 0,
        y: -17,
        rotate: 30,
      }, '-=1')
      .to('.front-twenty .glass-twenty__9', {
        duration: 1,
        x: 0,
        y: 5,
        rotate: -10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__10', {
        duration: 1,
        x: -55,
        y: -35,
        rotate: 20,
      }, '-=1')
      .to('.front-twenty .glass-twenty__11', {
        duration: 1,
        x: -40,
        y: -25,
        rotate: 10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__12', {
        duration: 1,
        x: -20,
        y: -25,
        rotate: 10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__13', {
        duration: 1,
        x: -20,
        y: 12,
        rotate: 10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__14', {
        duration: 1,
        x: -20,
        y: 2,
        rotate: 10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__15', {
        duration: 1,
        x: -25,
        y: 15,
        rotate: 10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__16', {
        duration: 1,
        x: 5,
        y: 10,
        rotate: -10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__17', {
        duration: 1,
        x: 5,
        y: 10,
        rotate: 10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__18', {
        duration: 1,
        x: 15,
        y: 10,
        rotate: 10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__19', {
        duration: 1,
        x: 5,
        y: 0,
        rotate: 15,
      }, '-=1')
      .to('.front-twenty .glass-twenty__20', {
        duration: 1,
        x: 10,
        y: 5,
        rotate: 20,
      }, '-=1')
      .to('.back-twenty .glass-twenty__5', {
        duration: 1,
        x: -23,
        y: -80,
        rotate: 20,
        scale: 1.1,
      }, '-=1')
      .to('.back-twenty .glass-twenty__6', {
        duration: 1,
        x: -23,
        y: -35,
        rotate: 20,
        scale: 1.1,
      }, '-=1')
      .to('.back-twenty .glass-twenty__2', {
        duration: 1,
        x: -43,
        y: -10,
        rotate: -90,
      }, '-=1')
      .to('.back-twenty .glass-twenty__8', {
        duration: 1,
        x: -3,
        y: -50,
        rotate: -10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__3', {
        duration: 1,
        x: 3,
        y: -30,
        rotate: 10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__1', {
        duration: 1,
        x: -3,
        y: -20,
        rotate: 20,
      }, '-=1')
      .to('.back-twenty .glass-twenty__4', {
        duration: 1,
        x: -3,
        y: -20,
        rotate: 20,
      }, '-=1')
      .to('.back-twenty .glass-twenty', {
        duration: 1,
        x: 0,
        y: -17,
        rotate: 30,
      }, '-=1')
      .to('.back-twenty .glass-twenty__13', {
        duration: 1,
        x: 0,
        y: 5,
        rotate: -10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__9', {
        duration: 1,
        x: -55,
        y: -35,
        rotate: 20,
      }, '-=1')
      .to('.back-twenty .glass-twenty__12', {
        duration: 1,
        x: -40,
        y: -25,
        rotate: 10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__11', {
        duration: 1,
        x: -20,
        y: -25,
        rotate: 10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__7', {
        duration: 1,
        x: -20,
        y: 12,
        rotate: 10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__10', {
        duration: 1,
        x: -20,
        y: 2,
        rotate: 10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__14', {
        duration: 1,
        x: -25,
        y: 15,
        rotate: 10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__19', {
        duration: 1,
        x: 5,
        y: 10,
        rotate: -10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__16', {
        duration: 1,
        x: 5,
        y: 10,
        rotate: 10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__20', {
        duration: 1,
        x: 15,
        y: 10,
        rotate: 10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__17', {
        duration: 1,
        x: 5,
        y: 0,
        rotate: 15,
      }, '-=1')
      .to('.back-twenty .glass-twenty__15', {
        duration: 1,
        x: 10,
        y: 5,
        rotate: 20,
      }, '-=1')
      .to('.back-twenty .glass-twenty__18', {
        duration: 1,
        x: 10,
        y: 5,
        rotate: 20,
      }, '-=1')
      .to('.front-twenty .glass-twenty__21', {
        duration: 1,
        x: 0,
        y: -35,
        rotate: -10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__22', {
        duration: 1,
        x: 5,
        y: -25,
        rotate: 15,
      }, '-=1')
      .to('.front-twenty .glass-twenty__23', {
        duration: 1,
        x: 15,
        y: -10,
        rotate: 15,
      }, '-=1')
      .to('.front-twenty .glass-twenty__24', {
        duration: 1,
        x: 30,
        y: -30,
        rotate: -15,
      }, '-=1')
      .to('.front-twenty .glass-twenty__25', {
        duration: 1,
        x: 10,
        y: 5,
        rotate: 15,
      }, '-=1')
      .to('.front-twenty .glass-twenty__26', {
        duration: 1,
        x: 30,
        y: 20,
        rotate: 40,
      }, '-=1')
      .to('.front-twenty .glass-twenty__27', {
        duration: 1,
        x: 10,
        y: 30,
        rotate: -10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__28', {
        duration: 1,
        x: 20,
        y: 30,
        rotate: -15,
      }, '-=1')
      .to('.front-twenty .glass-twenty__29', {
        duration: 1,
        x: 35,
        y: 35,
        rotate: -70,
      }, '-=1')
      .to('.front-twenty .glass-twenty__30', {
        duration: 1,
        x: 45,
        y: 5,
        rotate: 10,
      }, '-=1')
      .to('.front-twenty .glass-twenty__31', {
        duration: 1,
        x: 85,
        y: -15,
        rotate: 80,
      }, '-=1')
      .to('.front-twenty .glass-twenty__32', {
        duration: 1,
        x: 85,
        y: -35,
        rotate: 80,
      }, '-=1')
      .to('.front-twenty .glass-twenty__33', {
        duration: 1,
        x: 30,
        y: -20,
        rotate: -80,
      }, '-=1')
      .to('.front-twenty .glass-twenty__34', {
        duration: 1,
        x: 10,
        y: -40,
        rotate: -80,
      }, '-=1')
      .to('.front-twenty .glass-twenty__35', {
        duration: 1,
        x: 0,
        y: -40,
        rotate: -90,
      }, '-=1')
      .to('.front-twenty .glass-twenty__36', {
        duration: 1,
        x: 0,
        y: -40,
        rotate: -90,
      }, '-=1')
      .to('.back-twenty .glass-twenty__23', {
        duration: 1,
        x: 0,
        y: -35,
        rotate: -10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__21', {
        duration: 1,
        x: 5,
        y: -25,
        rotate: 15,
      }, '-=1')
      .to('.back-twenty .glass-twenty__24', {
        duration: 1,
        x: 15,
        y: -10,
        rotate: 15,
      }, '-=1')
      .to('.back-twenty .glass-twenty__27', {
        duration: 1,
        x: 30,
        y: -30,
        rotate: -15,
      }, '-=1')
      .to('.back-twenty .glass-twenty__22', {
        duration: 1,
        x: 10,
        y: 5,
        rotate: 15,
      }, '-=1')
      .to('.back-twenty .glass-twenty__25', {
        duration: 1,
        x: 30,
        y: 20,
        rotate: 40,
      }, '-=1')
      .to('.back-twenty .glass-twenty__31', {
        duration: 1,
        x: 10,
        y: 30,
        rotate: -10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__26', {
        duration: 1,
        x: 20,
        y: 30,
        rotate: -15,
      }, '-=1')
      .to('.back-twenty .glass-twenty__28', {
        duration: 1,
        x: 35,
        y: 35,
        rotate: -70,
      }, '-=1')
      .to('.back-twenty .glass-twenty__30', {
        duration: 1,
        x: 45,
        y: 5,
        rotate: 10,
      }, '-=1')
      .to('.back-twenty .glass-twenty__29', {
        duration: 1,
        x: 85,
        y: -15,
        rotate: 80,
      }, '-=1')
      .to('.back-twenty .glass-twenty__36', {
        duration: 1,
        x: 85,
        y: -35,
        rotate: 80,
      }, '-=1')
      .to('.back-twenty .glass-twenty__35', {
        duration: 1,
        x: 30,
        y: -20,
        rotate: -80,
      }, '-=1')
      .to('.back-twenty .glass-twenty__33', {
        duration: 1,
        x: 10,
        y: -40,
        rotate: -80,
      }, '-=1')
      .to('.back-twenty .glass-twenty__34', {
        duration: 1,
        x: 0,
        y: -40,
        rotate: -90,
      }, '-=1')
      .to('.back-twenty .glass-twenty__32', {
        duration: 1,
        x: 0,
        y: -40,
        rotate: -90,
      }, '-=1');

    ScrollTrigger.create({
      trigger: '.twenty-section',
      start: '-40%',
      end: 'bottom',
      onUpdate: (self) => {
        console.log('progress:', self.progress);
        if (self.progress > 0.27) {
          document.body.style.background = '#1D1D1D';
          // TweenMax.to(
          //   '.main-section-container ', 3, {
          //     y: '-100%',
          //     opacity: 0,
          //     ease: 'expo.out',
          //   },
          // );
          TweenMax.to('.main-section-container .stripes-bg', 3, {
            backgroundPositionX: '0%',
            backgroundPositionY: '100%',
            ease: 'expo.out',
          });
        }
        if (self.progress < 0.27 && self.direction === -1) {
          document.body.style.background = '#E30611';
          // TweenMax.to(
          //   '.main-section-container', 3, {
          //     y: '0',
          //     opacity: 1,
          //     ease: 'expo.out',
          //   },
          // );
          TweenMax.to('.main-section-container .stripes-bg', 3, {
            backgroundPositionX: '38%',
            backgroundPositionY: '-5%',
            ease: 'expo.out',
          });
        }
      },
    });
  },
};
</script>

<style lang="scss">
.twenty-section{
  background-image: url('../assets/image/main-section/noise.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: top center;
  position: relative;
  height: calc(var(--vh) * 120);

  p{
    color: #ffffff;
    font-size: 25px;
  }

  .container{
    position: sticky;
    display: block;
    top: calc(var(--vh)*7);
    z-index: 15;
  }
}

.stripes-black-bg{
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  overflow: hidden;
}

.twenty-image{
  max-width: 80%;
  margin: 30px auto 0;
}

.back-twenty{
  opacity: .6;
  max-width: 80%;
  margin: 0 auto -30px;
  position: relative;
  z-index: 5;
  display: block;
  overflow: unset;
}

.front-twenty{
  position: relative;
  z-index: 10;
  overflow: unset;
}
</style>
